import React, { useEffect, useState } from "react";
import { ACTIONARROW_ICON, EDIT_ICON, RIGHTARROW_ICON } from "../../../utills/image-constant";
import AdminDataTable from "../../components/common/AdminDataTable";
import TableHeading from "../../components/common/TableHeading";
import SearchAndAddItem from "../../components/common/TableData";
import {
  blockRoleStatus,
  getallAdminRole,
} from "../../../services/api-services";
import { toastEmitter } from "../../../utills/utilities";
import { API_RESPONSE } from "../../../utills/app-constant";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../routes/url-constant";
import { useSelector } from "react-redux";
import AccessPermissionpage from "./AccessPermissionpage";

const RoleManegment = () => {
  const [pending, setPending] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalElement, settotalElement] = useState();
  const [searchText, setSearchText] = useState("");
  const [permissionAccess, setPermissionAccess] = useState();
  const [rowData, setRowData] = useState([]);
  const navigate = useNavigate();
  const { value } = useSelector((state) => state?.adminRole);
  const [sortColumn, setSortColumn] = useState("id");
  const [sortDirection, setSortDirection] = useState("desc");

  useEffect(() => {
    const RoleAccessFilterData =
      value && value?.filter((v) => v.moduleName === "Team Management");
    setPermissionAccess(RoleAccessFilterData?.[0]);
  }, [value]);

  const loggedUserDetails = useSelector((state) => state?.loggedUser?.value);

  const payload = {
    pageIndex: page,
    pageSize,
    searchText,
    direction: sortDirection,
    filterByFieldName: sortColumn,
  };

  const tableCustomStyles = {
    headRow: {
      style: {
        color: "#1B2128",
        fontSize: "14px",
      },
    },
    rows: {
      style: {
        color: "#1B2128",
        fontSize: "14px",
      },
    },
  };

  const getallRole = async () => {
    setPending(true);
    try {
      const response = await getallAdminRole(payload);
      if (response?.data?.responseCode === 404) {
        setRowData([]);
      } else if (response?.data?.responseCode === 200) {
        setRowData(response?.data?.responseBody?.roleList);
        settotalElement(response?.data?.responseBody?.totalElement);
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    } finally {
      setPending(false);
    }
  };

  // Fetch data on initial render and when page, pageSize, or searchText changes
  useEffect(() => {
    getallRole();
  }, [page, pageSize, searchText, sortColumn, sortDirection]);



  const handleStatusToggle = async (row) => {
    const newStatus = row?.status === 1 ? 0 : 1; // Toggle the status

    // Optimistically update the status in the local rowData
    const updatedRowData = rowData.map((item) =>
      item.id === row.id ? { ...item, status: newStatus } : item
    );
    setRowData(updatedRowData); // Update local state with the new status

    try {
      let response = await blockRoleStatus(row.id, newStatus);

      if (response?.data?.responseCode === 200) {
        toastEmitter("success", response?.data?.message);
      } else {
        // If the API fails, revert the status in local state
        const revertRowData = rowData.map((item) =>
          item.id === row.id ? { ...item, status: row?.status } : item
        );
        setRowData(revertRowData);
        console.error("Failed to update model status");
      }
    } catch (error) {
      // If there's an error, revert the status in local state
      const revertRowData = rowData.map((item) =>
        item.id === row.id ? { ...item, status: row?.status } : item
      );
      setRowData(revertRowData);
      console.error("Error during status change:", error);
    }
  };


  const handleModelSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleAddRole = () => {
    navigate(ROUTES?.ADDROLE);
  };

  const tblColumns = [
    {
      code: "Action",
      name: "Action",
      width: "150px",
      sortable: false,
      cell: (row) => (
        <div className="">
          <button className="border-0 bg-white">
            {loggedUserDetails?.roleResponsePayload?.roleName !==
              row?.roleName &&
              permissionAccess?.updateAction === 1 && (
                <img
                  src={EDIT_ICON}
                  alt="Edit"
                  className="editicon"
                  onClick={() =>
                    navigate(ROUTES?.ADDROLE, {
                      state: { pageType: "Edit", Data: row },
                    })
                  }
                />
              )}
            {permissionAccess?.viewAction === 1 && (
              <span>
                <img
                  src={ACTIONARROW_ICON}
                  alt="Edit"
                  className="editicon ms-2"
                  onClick={() =>
                    navigate(ROUTES?.ADDROLE, {
                      state: { pageType: "view", Data: row },
                    })
                  }
                />
              </span>
            )}
          </button>
        </div>
      ),
    },
    {
      code: "roleName",
      name: "Role Name",
      sortable: true,
      selector: (row) => `${row?.roleName}`,
    },
    {
      code: "status",
      name: "Status",
      omit: false,
      sortable: true,
      selector: (row) => (
        <div className="form-switch-btn">
          <label className="switch">
            <input
              disabled={permissionAccess?.moduleAction === 0}
              type="checkbox"
              id="togBtn"
              checked={row.status === 1} // Checked if active
              onChange={() => handleStatusToggle(row)}
            />
            <div className="slider round">
              <span className="on">Active</span>
              <span className="off">Inactive</span>
            </div>
          </label>
        </div>
      ),
    },
    {
      code: "entryDate",
      name: "Last Update",
      sortable: true,
      selector: (row) => moment(row?.entryDate).format("DD/MM/YYYY"),
    },

  ];

  return (
    <>
      {permissionAccess?.addAction == 0 &&
        permissionAccess?.updateAction == 0 &&
        permissionAccess?.viewAction === 0 ? (
        <>
          <AccessPermissionpage />
        </>
      ) : (
        <>
          <div className="modal_datatable">
            <TableHeading firstData="Team Management" icon={RIGHTARROW_ICON} secondData="Team Role Access" />
            <div className="container-fluid ">
              <div className="caspera_admin_datatable mb-3">
                <SearchAndAddItem
                  // title="Team Role Access"
                  searchValue={searchText}
                  onSearchChange={handleModelSearchChange}
                  addButtonClick={handleAddRole}
                  data="Role"
                  permissionAccessbtn={permissionAccess?.addAction}
                />

                <AdminDataTable
                  _tblColumns={tblColumns}
                  _rowData={rowData}
                  tableCustomStyles={tableCustomStyles}
                  _totalRows={totalElement}
                  pending={pending}
                  setPending={setPending}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  setPage={setPage}
                  totalElement={totalElement}
                  setSortColumn={setSortColumn}
                  setSortDirection={setSortDirection}
                />
                {/* )} */}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default RoleManegment;
